/**
 * rest:ln — the frame every Learn page shares (owner L1): no rail and no cap, the main column the
 * whole content box at every width (mock `cols--norail`), its blocks 32 apart (mock `ln-body`).
 * Spread onto `ScreenLayout`, on the loaded page, its pending page and its not-found page alike,
 * so the column never changes width between them.
 *
 * The strip's own wrapper is the column's first child and pulls the next block up by the gap less
 * 16 (ScreenLayout's `lg:-mb-2` is sized for the default 24 gap): the mock's 16 from the strip's
 * hairline to the first block holds at the 32 gap too.
 */
export const LEARN_PAGE = { fullWidth: true, mainClassName: 'gap-8 lg:*:first:-mb-4!' } as const

/**
 * A drill-down's two columns (a path step, a dictionary word): the main column takes the rest,
 * the aside is the mock's 352 (760 + 24 + 352 at a 1440 window). One column below `@3xl`; the
 * aside's blocks stand 32 apart, as the mock's do.
 */
export const LEARN_COLUMNS =
  'grid grid-cols-1 gap-8 @3xl:grid-cols-[minmax(0,1fr)_--spacing(88)] @3xl:items-start @3xl:gap-6'

export const LEARN_ASIDE = 'flex min-w-0 flex-col gap-8'

/** The mock's `ln-chev`: a 16 chevron in the tertiary ink that slides 2px on its row's hover. */
export const LEARN_CHEVRON = 'size-4 shrink-0 text-muted-foreground-subtle'
